(function () {
  'use strict';

  var syncSequence = 0;
  var drawerCloseTimer = 0;
  var lastDrawerOpenAt = 0;
  var readController = null;
  var currentCart = null;
  var cartIsCurrent = false;
  var mutationPending = false;
  var refreshAfterMutation = false;
  var pendingDrawerAnnouncement = false;
  var drawerReturnFocus = null;

  function shopUrl(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

    return root.replace(/\/?$/, '/') + path;
  }

  function displayCount(count) {
    return count > 99 ? '99+' : String(count);
  }

  function applyCount(count) {
    var safeCount = Number.isFinite(count) && count > 0 ? Math.floor(count) : 0;
    var visibleCount = displayCount(safeCount);
    var itemLabel = safeCount === 1 ? 'item' : 'items';
    var announcement = 'Total items in cart: ' + safeCount;

    document.querySelectorAll('[data-p4m-retail-header] [ref="cartBubbleCount"]').forEach(function (node) {
      node.textContent = visibleCount;
    });

    document.querySelectorAll('[data-p4m-retail-header] [ref="cartBubbleText"] > .visually-hidden').forEach(function (node) {
      node.textContent = announcement;
    });

    document.querySelectorAll('[data-p4m-retail-header] a[href$="/cart"]').forEach(function (link) {
      link.setAttribute('aria-label', 'Cart, ' + safeCount + ' ' + itemLabel);
    });

    document.querySelectorAll('[data-p4m-retail-header] [ref="cartBubbleText"][role="status"]').forEach(function (status) {
      status.setAttribute('aria-label', announcement);
    });
  }

  function invalidateCartRead() {
    syncSequence += 1;
    if (readController) readController.abort();
    readController = null;
    cartIsCurrent = false;
    updateControls();
  }

  function showStatus(message, isError, retry) {
    var root = document.querySelector('[data-p4m-cart-drawer]');
    if (!root) return;
    var status = root.querySelector('[data-p4m-cart-drawer-status]');
    status.textContent = message;
    status.classList.toggle('is-error', Boolean(isError));
    root.querySelector('[data-p4m-cart-drawer-retry]').hidden = !retry;
  }

  function updateControls() {
    var root = document.querySelector('[data-p4m-cart-drawer]');
    if (!root) return;
    var busy = mutationPending || !cartIsCurrent;
    root.querySelector('[data-p4m-cart-drawer-items]').setAttribute('aria-busy', String(busy));
    root.querySelectorAll('[data-p4m-cart-action]').forEach(function (button) {
      button.disabled = busy;
    });
    var checkout = root.querySelector('.p4m-cart-drawer__checkout');
    var canCheckout = !busy && currentCart && Number(currentCart.item_count) > 0;
    checkout.setAttribute('aria-disabled', String(!canCheckout));
    if (canCheckout) {
      checkout.href = shopUrl('checkout');
      checkout.setAttribute('data-p4m-checkout', '');
      checkout.removeAttribute('tabindex');
    } else {
      // Removing the target also prevents recording a blocked click as a checkout attempt.
      checkout.removeAttribute('href');
      checkout.removeAttribute('data-p4m-checkout');
      checkout.setAttribute('tabindex', '-1');
    }
    var view = root.querySelector('.p4m-cart-drawer__view');
    view.setAttribute('aria-disabled', String(mutationPending));
    if (mutationPending) view.removeAttribute('href');
    else view.href = shopUrl('cart');
  }

  function applyCart(cart) {
    if (!cart || !Array.isArray(cart.items) || !Number.isFinite(Number(cart.item_count))) {
      throw new Error('Invalid cart response');
    }
    currentCart = cart;
    cartIsCurrent = true;
    applyCount(Number(cart.item_count));
    var root = document.querySelector('[data-p4m-cart-drawer]');
    if (root) renderDrawer(cart);
    updateControls();
  }

  async function syncCartCount() {
    if (mutationPending) {
      refreshAfterMutation = true;
      invalidateCartRead();
      return null;
    }
    invalidateCartRead();
    var sequence = syncSequence;
    var controller = new AbortController();
    readController = controller;

    try {
      var response = await fetch(shopUrl('cart.js'), {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        signal: controller.signal,
        headers: {
          accept: 'application/json'
        }
      });

      if (!response.ok) throw new Error('Cart count request failed (' + response.status + ')');
      var cart = await response.json();
      if (sequence !== syncSequence || mutationPending) return null;
      applyCart(cart);
      if (pendingDrawerAnnouncement) {
        pendingDrawerAnnouncement = false;
        if (window.P4MFunnel && typeof window.P4MFunnel.publish === 'function') {
          window.P4MFunnel.publish('p4m_cart_drawer_opened', {
            interaction: 'confirmed_mobile_add',
            item_count: Number(cart.item_count || 0)
          });
        }
      }
      return cart;
    } catch (error) {
      if (sequence !== syncSequence) return null;
      showStatus(pendingDrawerAnnouncement ? 'Added successfully. Open your cart to continue.' : 'We could not refresh your cart. Try again or open View cart.', true, true);
      return null;
    } finally {
      if (sequence === syncSequence) readController = null;
    }
  }

  function money(cents, currency) {
    var amount = Number(cents || 0) / 100;
    var activeCurrency = currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: activeCurrency
      }).format(amount);
    } catch (error) {
      return '$' + amount.toFixed(2);
    }
  }

  function drawerRoot() {
    var current = document.querySelector('[data-p4m-cart-drawer]');
    if (current) return current;

    var root = document.createElement('div');
    root.className = 'p4m-cart-drawer';
    root.dataset.p4mCartDrawer = '';
    root.hidden = true;
    root.setAttribute('aria-hidden', 'true');
    root.innerHTML = [
      '<button class="p4m-cart-drawer__backdrop" type="button" data-p4m-cart-drawer-close tabindex="-1" aria-label="Close cart"></button>',
      '<aside class="p4m-cart-drawer__panel" role="dialog" aria-modal="true" aria-labelledby="P4MCartDrawerTitle">',
      '  <header class="p4m-cart-drawer__header">',
      '    <div><small>Added to your cart</small><h2 id="P4MCartDrawerTitle">Your cart</h2></div>',
      '    <button class="p4m-cart-drawer__close" type="button" data-p4m-cart-drawer-close aria-label="Close cart">&times;</button>',
      '  </header>',
      '  <div class="p4m-cart-drawer__notice"><div class="p4m-cart-drawer__status" data-p4m-cart-drawer-status role="status" aria-live="polite" aria-atomic="true">Updating your cart...</div><button type="button" class="p4m-cart-drawer__retry" data-p4m-cart-drawer-retry hidden>Try again</button></div>',
      '  <div class="p4m-cart-drawer__items" data-p4m-cart-drawer-items></div>',
      '  <footer class="p4m-cart-drawer__footer">',
      '    <div class="p4m-cart-drawer__subtotal"><span>Subtotal</span><strong data-p4m-cart-drawer-total>-</strong></div>',
      '    <p>Discounts, shipping, and taxes are confirmed at checkout.</p>',
      '    <a class="p4m-cart-drawer__checkout" href="/checkout" data-p4m-checkout>Checkout</a>',
      '    <a class="p4m-cart-drawer__view" href="/cart">View cart</a>',
      '    <button class="p4m-cart-drawer__continue" type="button" data-p4m-cart-drawer-close>Continue shopping</button>',
      '  </footer>',
      '</aside>'
    ].join('');

    root.addEventListener('click', function (event) {
      var disabled = event.target && event.target.closest && event.target.closest('[aria-disabled="true"]');
      if (disabled) {
        event.preventDefault();
        return;
      }
      var close = event.target && event.target.closest && event.target.closest('[data-p4m-cart-drawer-close]');
      if (close) closeDrawer();
      var retry = event.target && event.target.closest && event.target.closest('[data-p4m-cart-drawer-retry]');
      if (retry) {
        showStatus('Updating your cart...', false, false);
        syncCartCount();
      }
      var action = event.target && event.target.closest && event.target.closest('[data-p4m-cart-action]');
      if (action && !action.disabled) changeQuantity(action);
    });
    root.querySelector('.p4m-cart-drawer__view').href = shopUrl('cart');
    document.body.appendChild(root);
    updateControls();
    return root;
  }

  function createCartItem(item, currency) {
    var row = document.createElement('article');
    row.className = 'p4m-cart-drawer__item';
    row.dataset.cartKey = item.key || '';

    var imageLink = document.createElement('a');
    imageLink.className = 'p4m-cart-drawer__image';
    imageLink.href = item.url || shopUrl('cart');
    var imageUrl = item.featured_image && item.featured_image.url ? item.featured_image.url : item.image;
    if (imageUrl) {
      var image = document.createElement('img');
      image.src = imageUrl;
      image.alt = item.featured_image && item.featured_image.alt ? item.featured_image.alt : item.product_title || item.title || '';
      image.loading = 'eager';
      image.width = 88;
      image.height = 88;
      imageLink.appendChild(image);
    }

    var copy = document.createElement('div');
    copy.className = 'p4m-cart-drawer__item-copy';
    var title = document.createElement('a');
    title.className = 'p4m-cart-drawer__item-title';
    title.href = item.url || shopUrl('cart');
    title.textContent = item.product_title || item.title || 'Cart item';
    copy.appendChild(title);

    if (item.variant_title && item.variant_title !== 'Default Title') {
      var variant = document.createElement('span');
      variant.className = 'p4m-cart-drawer__item-variant';
      variant.textContent = item.variant_title;
      copy.appendChild(variant);
    }

    var meta = document.createElement('div');
    meta.className = 'p4m-cart-drawer__item-meta';
    var quantity = document.createElement('div');
    quantity.className = 'p4m-cart-drawer__quantity';
    quantity.setAttribute('role', 'group');
    var itemLabel = item.title || item.product_title || 'Cart item';
    quantity.setAttribute('aria-label', 'Quantity for ' + itemLabel);
    var quantityValue = document.createElement('span');
    quantityValue.textContent = String(Number(item.quantity || 0));
    quantityValue.setAttribute('aria-label', 'Quantity: ' + Number(item.quantity || 0));
    function actionButton(action, label, text) {
      var button = document.createElement('button');
      button.type = 'button';
      button.dataset.p4mCartAction = action;
      button.setAttribute('aria-label', label + ' ' + itemLabel);
      button.textContent = text;
      // Never fall back to variant IDs: different lines can share the same variant.
      button.disabled = !item.key;
      return button;
    }
    if (item.key) {
      quantity.append(actionButton('decrease', 'Decrease quantity of', '−'), quantityValue, actionButton('increase', 'Increase quantity of', '+'));
    } else {
      quantity.appendChild(quantityValue);
    }
    var price = document.createElement('strong');
    price.textContent = money(item.final_line_price, currency);
    meta.append(quantity, price);
    copy.appendChild(meta);
    if (item.key) {
      var remove = actionButton('remove', 'Remove', 'Remove');
      remove.className = 'p4m-cart-drawer__remove';
      copy.appendChild(remove);
    }

    row.append(imageLink, copy);
    return row;
  }

  function renderDrawer(cart) {
    var root = drawerRoot();
    var items = root.querySelector('[data-p4m-cart-drawer-items]');
    var status = root.querySelector('[data-p4m-cart-drawer-status]');
    var total = root.querySelector('[data-p4m-cart-drawer-total]');
    var cartItems = Array.isArray(cart.items) ? cart.items : [];

    if (items) {
      var scrollTop = items.scrollTop;
      items.replaceChildren.apply(items, cartItems.map(function (item) {
        return createCartItem(item, cart.currency);
      }));
      items.scrollTop = scrollTop;
    }
    if (status) {
      showStatus(cart.item_count === 0 ? 'Your cart is empty.' : cart.item_count === 1 ? '1 item is ready in your cart.' : String(cart.item_count) + ' items are ready in your cart.', false, false);
    }
    if (total) total.textContent = money(cart.total_price, cart.currency);
  }

  function openDrawerShell() {
    var root = drawerRoot();
    if (drawerCloseTimer) window.clearTimeout(drawerCloseTimer);
    if (root.hidden) drawerReturnFocus = document.activeElement;
    showStatus('Updating your cart...', false, false);
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('p4m-cart-drawer-open');
    updateControls();
    document.dispatchEvent(new CustomEvent('p4m:cart-drawer-open'));
    window.requestAnimationFrame(function () {
      root.classList.add('is-open');
      var close = root.querySelector('.p4m-cart-drawer__close');
      if (close) close.focus({ preventScroll: true });
    });
  }

  function closeDrawer() {
    var root = document.querySelector('[data-p4m-cart-drawer]');
    if (!root || root.hidden) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('p4m-cart-drawer-open');
    if (drawerReturnFocus && drawerReturnFocus.isConnected && typeof drawerReturnFocus.focus === 'function') {
      drawerReturnFocus.focus({ preventScroll: true });
    }
    drawerCloseTimer = window.setTimeout(function () {
      root.hidden = true;
    }, 240);
  }

  function openConfirmedCartDrawer(event) {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    var component = event.target && event.target.closest && event.target.closest('product-form-component');
    if (!component) return;
    var detail = event.detail && (event.detail.data || event.detail);
    if (detail && detail.didError) return;

    var now = Date.now();
    var current = document.querySelector('[data-p4m-cart-drawer]');
    var isOpen = current && !current.hidden && current.getAttribute('aria-hidden') === 'false';
    if (isOpen && now - lastDrawerOpenAt < 900) return;
    lastDrawerOpenAt = now;
    pendingDrawerAnnouncement = true;
    openDrawerShell();
  }

  async function changeQuantity(button) {
    if (mutationPending || !cartIsCurrent || !currentCart) return;
    var row = button.closest('[data-cart-key]');
    var key = row && row.dataset.cartKey;
    var item = currentCart.items.find(function (line) { return line.key === key; });
    if (!item || !key) return;
    var action = button.dataset.p4mCartAction;
    var quantity = action === 'remove' ? 0 : Math.max(0, Number(item.quantity) + (action === 'increase' ? 1 : -1));
    if (!Number.isInteger(quantity)) return;
    var focusIndex = currentCart.items.indexOf(item);
    mutationPending = true;
    refreshAfterMutation = false;
    invalidateCartRead();
    showStatus(quantity === 0 ? 'Removing item...' : 'Updating quantity...', false, false);
    var result = null;
    var failureMessage = '';

    try {
      var response = await fetch(shopUrl('cart/change.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      });
      result = await response.json();
      if (!response.ok || !result || !Array.isArray(result.items)) {
        var description = result && (result.description || result.message);
        failureMessage = typeof description === 'string' ? description : 'We could not update this quantity.';
        result = null;
      }
    } catch (error) {
      // An interrupted response can still represent a committed change. Do not retry the POST.
      failureMessage = 'We could not confirm the change. Please check the refreshed quantity.';
    }
    mutationPending = false;
    if (result && !refreshAfterMutation) {
      try { applyCart(result); } catch (error) { result = null; }
    } else {
      result = null;
    }
    refreshAfterMutation = false;
    if (!result) {
      var recovery = syncCartCount();
      var recoverySequence = syncSequence;
      result = await recovery;
      // A newer cart event now owns status, focus, and controls as well as the cart data.
      if (recoverySequence !== syncSequence) return;
    }
    updateControls();
    if (!result) {
      showStatus('We could not confirm your cart. Try again or open View cart before checkout.', true, true);
    } else if (failureMessage) {
      showStatus(failureMessage, true, false);
    } else {
      var updatedItem = result.items.find(function (line) { return line.key === key; });
      if (updatedItem && Number(updatedItem.quantity) < quantity) {
        showStatus('Your cart was updated to the available quantity (' + Number(updatedItem.quantity) + ').', true, false);
      }
    }
    // Re-rendering replaces the focused button. Preserve keyboard position, including after removal.
    var root = drawerRoot();
    if (!root.hidden && root.getAttribute('aria-hidden') === 'false') {
      var rows = root.querySelectorAll('[data-cart-key]');
      var targetRow = Array.from(rows).find(function (line) { return line.dataset.cartKey === key; }) || rows[Math.min(focusIndex, rows.length - 1)];
      var focusTarget = targetRow && targetRow.querySelector('[data-p4m-cart-action="' + action + '"]');
      if (!focusTarget || focusTarget.disabled) focusTarget = root.querySelector('.p4m-cart-drawer__close');
      focusTarget.focus({ preventScroll: true });
    }
  }

  document.addEventListener('cart:update', function (event) {
    openConfirmedCartDrawer(event);
    syncCartCount();
  });

  document.addEventListener('p4m:support-open', closeDrawer);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDrawer();
    if (event.key !== 'Tab') return;
    var root = document.querySelector('[data-p4m-cart-drawer]');
    if (!root || root.hidden || root.getAttribute('aria-hidden') === 'true') return;
    var focusable = Array.from(root.querySelectorAll('a[href], button:not([disabled])')).filter(function (node) {
      return !node.hidden && node.getAttribute('tabindex') !== '-1';
    });
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && (document.activeElement === first || !root.contains(document.activeElement))) {
      event.preventDefault();
      if (last) last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !root.contains(document.activeElement))) {
      event.preventDefault();
      if (first) first.focus();
    }
  });

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) syncCartCount();
  });

  window.addEventListener('resize', function () {
    if (!window.matchMedia('(max-width: 749px)').matches) closeDrawer();
  });
})();
